import React, { useState } from "react";
import { Button, Drawer } from "antd";
import ProductionTable from "./components/ProductionTable";
import ProductionForm from "./components/ProductionForm";
import { useDispatch, useSelector } from "react-redux";
import {
  toggleNewDialog,
  setSelectedPro,
  emptySelectedProduction,
} from "./store/stateSlice";
import { injectReducer } from "../../store";
import Productionreducer from "./store";
import ProductionTablemain from "./components/ProductionTablemain";
injectReducer("production", Productionreducer);
const Productionplan = () => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const dialog = useSelector((state) => state.production.state.newDialog);
  const handleClose = () => {
    dispatch(toggleNewDialog(false));
  };

  const onDialog = () => {
    dispatch(emptySelectedProduction([]));
    dispatch(toggleNewDialog(true));
  };
  return (
    <>
      <div className="bg-white m-4 p-8 rounded-xl">
        <div className="flex justify-between mb-6">
          <div className="text-xl font-bold !text-[#414141]">
            Production Planning
          </div>
          <div className="flex">
            <div className="flex items-center">
              {/* <FormSearch /> */}
              <Button type="primary" onClick={onDialog}>
                Add New Product
              </Button>
              <Drawer
                title="Add New Product"
                onClose={handleClose}
                open={dialog}
                width={1500}
              >
                <ProductionForm type={"new"} />
              </Drawer>
            </div>
          </div>
        </div>

        <ProductionTablemain />
      </div>
    </>
  );
};

export default Productionplan;
